/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Childnodes1Inputs */

const zh_course_childnodes1 = /** @type {(inputs: Course_Childnodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子节点`)
};

const en_course_childnodes1 = /** @type {(inputs: Course_Childnodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Child Nodes`)
};

const es_course_childnodes1 = /** @type {(inputs: Course_Childnodes1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodos hijos`)
};

/**
* | output |
* | --- |
* | "Child Nodes" |
*
* @param {Course_Childnodes1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_childnodes1 = /** @type {((inputs?: Course_Childnodes1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Childnodes1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_childnodes1(inputs)
	if (locale === "en") return en_course_childnodes1(inputs)
	return es_course_childnodes1(inputs)
});
export { course_childnodes1 as "course_childNodes" }